module.exports = __webpack_public_path__ + "media/yoga-flow.0024e84e.mp4";